import { postApiGalaxyServer } from 'services/api';

export type CheckOdbcCredentialsPayload = {
  credentials: {
    password: string;
    username: string;
    dataSource: string;
    serviceUrl: string;
  };
  query: string;
};

export type CheckOdbcCredentialsResponse = {
  data: unknown;
};

export const checkOdbcCredentialsApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<CheckOdbcCredentialsPayload>) => {
  return postApiGalaxyServer<CheckOdbcCredentialsPayload, CheckOdbcCredentialsResponse>(
    `/intg_agents_api/odbc/executeQuery`,
    params,
    config,
    token,
  );
};
